import { initializeApp } from "firebase/app"
import * as FirebaseAuth from "firebase/auth"
import * as FirebaseStorage from "firebase/storage"
import * as Firestore from "firebase/firestore"
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "firebase/app-check"
import type { AppCheck } from "firebase/app-check"
import createClient from "openapi-fetch"
import { config } from "~/config"
import * as apisFront from "popopo-msg/api/schema"
import * as apisFrontDebug from "popopo-msg/api/schema-debug"

const app = initializeApp(config.firebase)

export const auth = FirebaseAuth.getAuth(app)
export const storage = FirebaseStorage.getStorage(app)
export const firestore = Firestore.getFirestore(app)
export const trtcAppId = config.trtc.appId

if (config.env === "local") {
  FirebaseAuth.connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true })
  FirebaseStorage.connectStorageEmulator(storage, "localhost", 9199)
  Firestore.connectFirestoreEmulator(firestore, "localhost", 8080)
}

// Firebase App Check の初期化（reCAPTCHA v3）
// localhost では recaptchaSiteKey が null のため初期化しない
let appCheck: AppCheck | undefined
if (config.recaptchaSiteKey) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(config.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  })
}

export const api = createClient<apisFront.paths & apisFrontDebug.paths>({
  baseUrl: config.apiUrl,
  headers: {
    "user-agent": "popopo-web",
  },
})

// App Check トークンを全リクエストに自動付与するミドルウェア
if (appCheck) {
  const appCheckInstance = appCheck
  api.use({
    async onRequest(req) {
      try {
        const tokenResponse = await getToken(appCheckInstance)
        req.headers.set("X-Firebase-AppCheck", tokenResponse.token)
      } catch (e) {
        console.warn("App Check トークンの取得に失敗しました", e)
      }
      return req
    },
  })
}
